import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function BackArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M19 12H5m0 0l7 7m-7-7l7-7" />
    </svg>
  );
}

/**
 * The app sends no email. Someone who forgot their password asks at a centre,
 * and the team hands them a link to set a new one.
 */
export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Esqueceu-se da palavra-passe | AICD</title>
      </Helmet>
      <div className="relative min-h-screen overflow-hidden bg-background">
        <span
          className="phone-bg-blob"
          style={{
            width: 260,
            height: 260,
            top: -60,
            right: -80,
            backgroundColor: 'hsla(var(--accent-purple), 0.12)',
          }}
          aria-hidden="true"
        />

        <div className="relative z-10 mx-auto w-full max-w-md px-6 pt-8 pb-12">
          <button
            type="button"
            className="back-link"
            onClick={() => navigate('/login')}
            aria-label="Voltar ao início de sessão"
          >
            <BackArrowIcon />
            Voltar
          </button>

          <header className="mt-2">
            <h1 className="text-[26px] font-extrabold tracking-tight text-foreground">
              Esqueceu-se da palavra-passe?
            </h1>
          </header>

          <div className="mt-8 rounded-xl border border-border bg-card px-4 py-4 text-sm text-foreground space-y-2">
            <p>
              Dirija-se ao <strong>CICF</strong> ou ao <strong>CCDV</strong> e peça ajuda à equipa.
            </p>
            <p className="text-muted-foreground">
              A equipa dá-lhe uma ligação para definir uma nova palavra-passe. A ligação funciona uma
              vez e durante 24 horas.
            </p>
          </div>

          <p className="mt-8 text-center text-sm text-muted-foreground">
            Lembrou-se da palavra-passe?{' '}
            <Link to="/login" className="font-semibold text-primary">
              Iniciar sessão
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
